/**
 * Is a keyboard event's target a text-entry control? The tour owns Escape in
 * the capture phase (it is the topmost layer), but a field's own Escape —
 * cancelling an inline rename, closing a Select, reverting an inspector
 * value — must reach the field: a stray Esc in a text box must never become
 * a permanent "Not now". Structurally typed so the rule is provable without
 * a DOM (the browser passes an HTMLElement; the test passes plain objects).
 */
export interface TypingTargetLike {
  tagName?: string;
  isContentEditable?: boolean;
}

const TYPING_TAGS: ReadonlySet<string> = new Set(["INPUT", "TEXTAREA", "SELECT"]);

export function isTypingTarget(t: unknown): boolean {
  if (!t || typeof t !== "object") return false;
  const el = t as TypingTargetLike;
  if (typeof el.tagName === "string" && TYPING_TAGS.has(el.tagName.toUpperCase())) return true;
  return el.isContentEditable === true;
}
